import React from 'react';
import { withRouter } from 'react-router-dom';
import { supportLink } from '../../config';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Divider, Header } from '@solarwindscloud/nighthawk-ui';
import Cookies from 'js-cookie';
import { errorCookieName } from '../../config';
const defaultMessage = 'Something went wrong.';

export const dataTestIds = {
  errorHeader: 'error-header',
  contactSupport: 'contact-support',
};

const ErrorPageComponent = () => {
  const message = Cookies.get(errorCookieName);
  return (
    <UnifiedLayout headerText={message || defaultMessage} dataTestId={dataTestIds.errorHeader} dataTestPageName="Error">
      <Header textAlign="center">
        <Header.Subheader>
          {message ? '' : 'Try to repeat the action.'}
          <Divider hidden />
          If you need help,{' '}
          <a href={supportLink} data-test-id={dataTestIds.contactSupport}>
            contact our support team
          </a>
          .
        </Header.Subheader>
      </Header>
    </UnifiedLayout>
  );
};

export const ErrorPage = withRouter(ErrorPageComponent);
